import { Components, Theme } from '@mui/material/styles';

/**
 * Create Alert Component Theme
 */
export const createAlertTheme = (
  theme: Theme,
  borderColor: 'light' | 'dark' = 'light',
): Components['MuiAlert'] => {
  return {
    defaultProps: {
      icon: true,
    },
    styleOverrides: {
      root: ({ ownerState }) => {
        const severity = ownerState?.severity || 'info';
        const severityColor = theme.palette[severity];
        const lightBg = (severityColor as any)['50'] || severityColor.light;
        const isInfoSeverity = severity === 'info';

        return {
          borderRadius: 12,
          border: `1px solid ${
            isInfoSeverity ? lightBg : severityColor[borderColor]
          } !important`,
          backgroundColor: `${lightBg} !important`,
          padding: theme.spacing(1.5, 2),
          alignItems: 'center',
          '& .MuiAlert-icon': {
            fontSize: 24,
          },
          '& .MuiAlert-message': {
            flex: 1,
            fontSize: 16,
            lineHeight: '24px',
          },
          '& .MuiAlert-action': {
            paddingTop: 0,
            marginLeft: theme.spacing(1),
            '& .MuiButton-root': {
              height: '40px',
              width: 'auto',
            },
          },
        };
      },
    },
  };
};

export default createAlertTheme;
